import type { SVGProps } from "react";

export function CookIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.16058 17.009L17.9996 17M11.9996 3C13.9176 3 15.5196 4.35 15.9096 6.151C16.9337 5.87385 18.026 6.01488 18.9461 6.54308C19.8663 7.07128 20.5389 7.94337 20.8161 8.9675C21.0932 9.99163 20.9522 11.0839 20.424 12.0041C19.8958 12.9242 19.0237 13.5968 17.9996 13.874V21H5.99958V13.874C5.49249 13.7366 5.01741 13.5007 4.60147 13.1798C4.18554 12.8588 3.8369 12.4591 3.57546 12.0034C3.31401 11.5477 3.14489 11.0449 3.07774 10.5239C3.01058 10.0028 3.04672 9.4736 3.18408 8.9665C3.32145 8.4594 3.55735 7.98432 3.87831 7.56839C4.19928 7.15246 4.59902 6.80382 5.05473 6.54237C5.51043 6.28093 6.01317 6.1118 6.53423 6.04465C7.0553 5.9775 7.58448 6.01364 8.09158 6.151C8.28542 5.25857 8.7788 4.45933 9.48973 3.88611C10.2007 3.31289 11.0863 3.0002 11.9996 3Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
